/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_TitleInputs */

const en_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Event or Text`)
};

const fr_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller Evenement ou Texte`)
};

const de_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis oder Text einfügen`)
};

const it_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla evento o testo`)
};

const ru_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие или текст`)
};

const es_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar evento o texto`)
};

const zh_cn2_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件或文本`)
};

const ja_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントまたはテキストを貼り付け`)
};

const hi_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट या टेक्स्ट पेस्ट करें`)
};

const pt_pt2_paste_title = /** @type {(inputs: Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar evento ou texto`)
};

/**
* | output |
* | --- |
* | "Paste Event or Text" |
*
* @param {Paste_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_title = /** @type {((inputs?: Paste_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_title(inputs)
	if (locale === "de") return de_paste_title(inputs)
	if (locale === "it") return it_paste_title(inputs)
	if (locale === "ru") return ru_paste_title(inputs)
	if (locale === "es") return es_paste_title(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_title(inputs)
	if (locale === "ja") return ja_paste_title(inputs)
	if (locale === "hi") return hi_paste_title(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_title(inputs)
	return en_paste_title(inputs)
});